import { Rx } from "subtree.js/core";
import { type FormStatus, idleForm } from "../../core/primitives/load-status";
import {
  EMPTY_PROFILE,
  type ProfileDraft,
  type ProfileErrors,
  type ProfileField,
} from "../../core/primitives/store-profile";

export class OnboardingShopState {
  /** The shop being edited, or null while this step creates one. */
  readonly storeId = new Rx<string | null>(null);
  /** Reviewing a claimed shop's details rather than creating a shop. */
  readonly claimReview = new Rx(false);
  /** The shop hosts its own page, so the description may no longer be cleared. */
  readonly hostsPage = new Rx(false);
  readonly draft = new Rx<ProfileDraft>(EMPTY_PROFILE);
  readonly errors = new Rx<ProfileErrors>({});
  readonly form = new Rx<FormStatus>(idleForm);
}

export abstract class OnboardingShopActions {
  abstract setField(field: ProfileField, value: string): void;
  abstract submit(): Promise<void>;
}
